import * as React from "react";
import { StyledBox, StyledTab, StyledTabs } from "./Styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box } from "@mui/material";
import { COLORS } from "../../constants";
import { Tab } from "../ExamBuilder/Reducers/ManipulateObjectivesReducer";
import DeleteObjectiveMenu from "../ExamBuilder/DeleteObjectiveMenu";
import { useEffect, useState } from "react";
import { handleClickTab } from "../ExamBuilder/Functions/FunctionsMain";
import { useSelector } from "react-redux";
import { RootState } from "../..";
import { deleteObjective } from "../ExamBuilder/Functions/FunctionsChangeObjectives";

interface ScrollableTabsButtonAutoProps {
  tabs: Tab[];
  activeTab: number;
}

const ScrollableTabsButtonAuto: React.FC<ScrollableTabsButtonAutoProps> = ({ tabs, activeTab }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [tabId, setTabId] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [deleteMenuOpen, setDeleteMenuOpen] = useState(false);
  const examData = useSelector((state: RootState) => state.examBuilder.main.examData);
  const selectedObjectiveId = useSelector((state: RootState) => state.examBuilder.main.selectedObjectiveId);

  useEffect(() => {
    setDeleteMenuOpen(false);
  }, [tabs]);

  function clickTab(tabId: string, tabIndex: number) {
    if (!deleteMenuOpen && selectedObjectiveId) {
      handleClickTab(tabId, tabIndex, selectedObjectiveId);
    }
  }

  function deleteTab() {
    if (selectedObjectiveId) {
      setAnchorEl(null);
      deleteObjective(tabId, tabIndex, selectedObjectiveId, examData, tabs, activeTab);
    }
  }

  const handleClickDeleteButton = (
    event: React.MouseEvent<SVGElement | HTMLElement>,
    tabId: string,
    tabIndex: number
  ) => {
    setDeleteMenuOpen(true);
    event.stopPropagation();
    setAnchorEl(event.currentTarget as HTMLElement);
    setTabId(tabId);
    setTabIndex(tabIndex);
  };

  const handleClose = () => {
    setDeleteMenuOpen(false);
    setAnchorEl(null);
  };

  return (
    <StyledBox>
      <StyledTabs value={activeTab} variant="scrollable" scrollButtons="auto" aria-label="scrollable auto tabs example">
        {tabs.map((tab, index) => (
          <StyledTab
            key={index}
            onClick={() => clickTab(tab.id, index)}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  gap: 1,
                  "&:hover .delete-icon": {
                    visibility: "visible",
                  },
                }}
              >
                {tab.label}

                <DeleteIcon
                  className="delete-icon"
                  fontSize="small"
                  onClick={(event) => handleClickDeleteButton(event, tab.id, index)}
                  sx={{
                    visibility: "hidden",
                    color: "gray",
                    "&:hover": {
                      color: COLORS.DIDACTO_DARK_RED,
                    },
                  }}
                />

                <DeleteObjectiveMenu anchorEl={anchorEl} handleClose={handleClose} deleteTab={deleteTab} />
              </Box>
            }
          />
        ))}
      </StyledTabs>
    </StyledBox>
  );
};

export default ScrollableTabsButtonAuto;
